<template>
    <div class="execution-privacy-changer">
        <a-alert
            type="info"
            show-icon
            :message="$t('automation.executionPrivacyTitle')"
            :description="$t('automation.executionPrivacyDescription')"
            class="mb-4"
        />

        <a-alert type="info" show-icon v-if="getIsPublic()" :message="$t('automation.executionPrivacyPublic')" />

        <div v-else class="lines">
            <div class="subtitle">{{ $t("message.visibleAgents") }}</div>
            <div class="agents">
                <div v-for="id of cloneUserIds" class="agent" :key="id">
                    <Avatar
                        :size="50"
                        :src="getUser(id) ? getUser(id).gravatar : undefined"
                        :username="getUser(id) ? getUser(id).name : 'N/A'"
                        class="mr-2 privacy-avatar"
                    />
                    <div
                        class="delete-icon"
                        @click="deleteAgent(id)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="getUser(id) ? getUser(id).name : 'N/A'"
                    ></div>
                </div>
                <div>
                    <button @click="openAgentModal" class="add-btn">
                        <span class="material-icons" style="color: #696a6b; padding-right: 2px"> add </span>
                    </button>
                </div>
            </div>

            <div class="subtitle">{{ $t("message.visibleDepartments") }}</div>
            <div class="agents">
                <div v-for="id of cloneDepartmentIds" class="agent" :key="id">
                    <Avatar
                        :size="50"
                        :src="undefined"
                        :username="getDepartmentTitle(getDepartment(id))"
                        class="mr-2 privacy-avatar"
                    />
                    <div
                        class="delete-icon"
                        @click="deleteDepartment(id)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="getDepartmentTitle(getDepartment(id))"
                    ></div>
                </div>
                <div>
                    <button @click="openDepartmentModal" class="add-btn">
                        <span class="material-icons" style="color: #696a6b; padding-right: 2px"> add </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="section-buttons">
            <a-button type="primary" @click="openAgentModal" class="privacy-button">
                {{ $t("message.editAgentVisibility") }}
            </a-button>
            <a-button type="primary" @click="openDepartmentModal" class="privacy-button">
                {{ $t("message.editDepartmentVisibility") }}
            </a-button>
            <a-button type="danger" @click="makePublic" class="privacy-button" v-if="!getIsPublic()">
                {{ $t("automation.makePublicExecution") }}
            </a-button>
        </div>

        <Modal2
            v-if="visibleAgentModal"
            :title="$t('message.selectAgent')"
            :show-footer="false"
            @cancel="visibleAgentModal = false"
        >
                <div class="pf-main">
                    <div class="pr-search">
                        <input :placeholder="$t('message.searchRepresentative')" v-model="searchText" />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div class="pr-item" v-for="agent of getFilteredUsers()" :key="agent._id" @click="toggleAgent(agent._id)">
                            <a-checkbox class="segment-checkbox" :checked="cloneUserIds.includes(agent._id)" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <Avatar
                                        :size="30"
                                        :src="agent.gravatar"
                                        :username="agent.name"
                                        class="mr-2 privacy-avatar"
                                    />
                                    <div class="metas">
                                        <div class="pr-item-name">{{ agent.name }}</div>
                                        <div>
                                            {{ getAgentDepartmentNames(agent) }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="pr-item-status"
                                    :data-online="$_.get(user, '_id') === agent._id ? true : agent.isOnline"
                                    :data-status="agent.status.toLowerCase()"
                                >
                                    <div class="pr-item-status-circle"></div>
                                    {{ agent.status }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="modal-footer-actions">
                <a-button @click="visibleAgentModal = false">{{ $t("message.cancelText") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary">
                    {{ $t("message.save") }}
                </a-button>
            </div>
        </Modal2>

        <Modal2
            v-if="visibleDepartmentModal"
            :title="$t('message.selectDepartment')"
            :show-footer="false"
            @cancel="visibleDepartmentModal = false"
        >
                <div class="pf-main">
                    <div class="pr-search">
                        <input :placeholder="$t('message.searchRepresentative')" v-model="searchText" />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div
                            class="pr-item"
                            v-for="item of getFilteredDepartments()"
                            :key="item._id"
                            @click="toogleDepartment(item._id)"
                        >
                            <a-checkbox class="segment-checkbox" :checked="cloneDepartmentIds.includes(item._id)" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <Avatar
                                        :size="30"
                                        :src="undefined"
                                        :username="item.languageContent[$i18n.locale].name"
                                        class="mr-2 privacy-avatar"
                                    />
                                    <div class="metas">
                                        <div class="pr-item-name">
                                            {{ item.languageContent[$i18n.locale].name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="pr-item-status">
                                    <div class="avatar-group">
                                        <Avatar
                                            v-for="user of getDepartmentUsers(item._id, 2)"
                                            :key="user._id"
                                            :size="30"
                                            :src="user.gravatar"
                                            :username="user.name"
                                            class="avatar-wrapper"
                                        />
                                        <div
                                            class="extra avatar-wrapper"
                                            v-if="getDepartmentUsers(item._id).length > 2"
                                        >
                                            +{{ getDepartmentUsers(item._id, 2).length - 2 }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="modal-footer-actions">
                <a-button @click="visibleDepartmentModal = false">{{ $t("message.cancelText") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary">
                    {{ $t("message.save") }}
                </a-button>
            </div>
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Modal2 from "../common/Modal2.vue";
import _ from "lodash";
import Avatar from "vue-avatar";

export default Vue.extend({
    name: "ExecutionPrivacyChanger",
    components: { Modal2, Avatar },
    props: {
        value: {
            type: Object,
            default: () => ({
                users: [],
                departments: [],
            }),
        },
    },
    data() {
        return {
            visibleAgentModal: false,
            visibleDepartmentModal: false,
            cloneUserIds: [],
            cloneDepartmentIds: [],
            searchText: "",
            isInternalUpdate: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            departments: (state) => state.subject.subjects.data,
        }),
    },
    methods: {
        openAgentModal() {
            this.searchText = "";
            this.visibleAgentModal = true;
        },
        openDepartmentModal() {
            this.searchText = "";
            this.visibleDepartmentModal = true;
        },
        getDepartmentTitle(department) {
            if (department === undefined) return "N/A";
            const langs = Object.keys(department.languageContent);
            const targetLang = langs.includes(this.$i18n.locale) ? this.$i18n.locale : langs[0];
            return _.get(department, `languageContent.${targetLang}.name`);
        },
        getUser(userId) {
            return this.users.find((user) => user._id === userId);
        },
        getIsPublic() {
            return this.cloneUserIds.length === 0 && this.cloneDepartmentIds.length === 0;
        },
        getDepartment(id) {
            return this.departments.find((department) => department._id === id);
        },
        getFilteredUsers() {
            let q = this.searchText.split("").join(".*");
            return this.users.filter((x) => new RegExp(q, "gi").test(x.name));
        },
        getFilteredDepartments() {
            let q = this.searchText.split("").join(".*");
            return this.departments.filter((x) => {
                const departmentName = this.getDepartmentTitle(x);
                return new RegExp(q, "gi").test(departmentName);
            });
        },
        deleteAgent(agentId) {
            this.toggleAgent(agentId);
            this.handleSaveImmediate();
        },
        deleteDepartment(departmentId) {
            this.toogleDepartment(departmentId);
            this.handleSaveImmediate();
        },
        toggleAgent(agentId) {
            this.cloneUserIds = this.cloneUserIds.includes(agentId)
                ? this.cloneUserIds.filter((x) => x !== agentId)
                : [...this.cloneUserIds, agentId];
        },
        toogleDepartment(departmentId) {
            this.cloneDepartmentIds = this.cloneDepartmentIds.includes(departmentId)
                ? this.cloneDepartmentIds.filter((x) => x !== departmentId)
                : [...this.cloneDepartmentIds, departmentId];
        },
        handleSaveImmediate() {
            this.isInternalUpdate = true;

            this.$emit("input", {
                users: [...this.cloneUserIds],
                departments: [...this.cloneDepartmentIds],
            });

            setTimeout(() => {
                this.isInternalUpdate = false;
            }, 100);
        },
        handleSave() {
            this.isInternalUpdate = true;

            this.visibleAgentModal = false;
            this.visibleDepartmentModal = false;

            this.$nextTick(() => {
                this.$emit("input", {
                    users: [...this.cloneUserIds],
                    departments: [...this.cloneDepartmentIds],
                });

                setTimeout(() => {
                    this.isInternalUpdate = false;
                }, 100);
            });
        },
        getAgentDepartmentNames(user) {
            return (user.subjects || []).length
                ? this.departments
                    .filter((x) => (user.subjects || []).includes(x._id))
                    .map(
                        (x) =>
                            _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                            _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`)
                    )
                    .join(",")
                    .toLowerCase()
                : this.$t("message.allDepartments");
        },
        getDepartmentUsers(departmentId, take) {
            const users = this.users.filter((x) => (x.subjects || []).includes(departmentId));
            if (take) {
                return users.slice(0, take);
            } else {
                return users;
            }
        },
        makePublic() {
            const self = this;
            this.$confirm({
                title: this.$t("automation.makePublicExecutionConfirmTitle"),
                content: this.$t("automation.makePublicExecutionConfirmContent"),
                okText: this.$t("message.yes"),
                cancelText: this.$t("message.cancelText"),
                onOk() {
                    self.cloneUserIds = [];
                    self.cloneDepartmentIds = [];
                    self.handleSaveImmediate();
                    self.$message.success(self.$t("automation.madePublicExecution"));
                },
            });
        },
    },
    mounted() {
        if (this.value) {
            this.cloneUserIds = [...(this.value.users || [])];
            this.cloneDepartmentIds = [...(this.value.departments || [])];
        }
    },
    watch: {
        value: {
            handler: function (val, oldVal) {
                if (!val) return;

                const usersChanged = !_.isEqual(val.users, oldVal ? oldVal.users : []);
                const departmentsChanged = !_.isEqual(val.departments, oldVal ? oldVal.departments : []);

                if (usersChanged || departmentsChanged) {
                    const currentUsersMatch = _.isEqual(val.users, this.cloneUserIds);
                    const currentDepartmentsMatch = _.isEqual(val.departments, this.cloneDepartmentIds);

                    if (this.isInternalUpdate && currentUsersMatch && currentDepartmentsMatch) {
                        return;
                    }

                    if (usersChanged && !currentUsersMatch) {
                        this.cloneUserIds = [...(val.users || [])];
                    }
                    if (departmentsChanged && !currentDepartmentsMatch) {
                        this.cloneDepartmentIds = [...(val.departments || [])];
                    }
                }
            },
            deep: true,
            immediate: false,
        },
    },
});
</script>

<style scoped lang="scss">
.execution-privacy-changer {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .lines {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .subtitle {
        font-weight: 700;
        color: var(--color-text-strong-default);
        font-size: 14px;
        line-height: 32px;
    }

    .section-buttons {
        display: flex;
        gap: 5px;
        margin-top: 10px;

        .privacy-button {
            word-wrap: break-word;
            white-space: normal;
            height: max-content;
        }
    }

    .agents {
        display: flex;
        flex-direction: row;
        gap: 5px;
        flex-wrap: wrap;

        .agent {
            position: relative;

            &:hover {
                .delete-icon {
                    display: grid;
                }
            }
        }
    }
}

.pf-main {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    border: 1px solid var(--color-border-default);
    padding: 5px;

    .pr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;

        input {
            border: 1px solid #c6cdd4 !important;
            width: 100%;
            padding: 10px;
            padding-right: 40px;
            border-radius: 5px;
            transition: all 0.3s;
        }

        input:focus {
            border: 1px solid black !important;
        }

        .pr-icon {
            position: absolute;
            right: 4px;
        }
    }

    .pr-items {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;

        .pr-item:last-child {
            border-bottom: none;
        }

        .pr-item {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: nowrap;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
            gap: 10px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            .user-data-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;

                padding: 0 5px;

                .user-data {
                    display: flex;
                    gap: 5px;
                    align-items: center;

                    .privacy-avatar {
                        color: var(--color-text-onprimary-default);
                    }

                    .metas {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }

            .pr-item-status {
                display: flex;
                justify-content: center;
                align-items: center;

                .pr-item-status-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 100%;
                    margin-right: 2px;
                }

                &[data-online="true"] {
                    &[data-status="online"] {
                        color: #1bc5bd !important;

                        .pr-item-status-circle {
                            background: #1bc5bd !important;
                        }
                    }

                    &[data-status="away"] {
                        color: #3699ff !important;

                        .pr-item-status-circle {
                            background: #3699ff !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: #ffa829 !important;

                        .pr-item-status-circle {
                            background: #ffa829 !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: #f64e60 !important;

                        .pr-item-status-circle {
                            background: #f64e60 !important;
                        }
                    }
                }

                &:not([data-online]) {
                    &[data-status="online"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="away"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }
                }
            }
        }
    }
}

.add-btn {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 1px dashed #696a6b;
    background: #ffffff;
}

.add-btn:hover {
    background: #696a6b;
    .material-icons {
        color: #ffffff !important;
    }
}

.avatar-group {
    display: inline-flex;
}

.avatar-wrapper {
    margin-inline-start: -8px;

    &.extra {
        width: 34px;
        height: 32px;
        border-radius: 50%;
        border-color: white;
        color: rgb(245, 106, 0);
        background-color: rgb(253, 227, 207);
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.avatar-wrapper:first-child {
    margin-inline-start: unset;
}

.delete-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    place-items: center;
    cursor: pointer;

    &:after {
        display: inline-block;
        content: "\00d7";
        color: rgba(255, 255, 255, 0.8);
        font-size: 35px;
    }
}

.modal-footer-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 15px 20px;
    border-top: 1px solid var(--color-border-default);
    margin-top: 20px;
}
</style>
<style lang="scss">
.privacy-avatar {
    span {
        color: var(--color-text-onprimary-default);
    }
}
</style>

